//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../assets/style/weui.css';
import '../../api/openjsbridge.icity.js'
export default {

  components: {

  },
  data() {
    return {
      phoneNo:'',
      unitNo:'',
      amount11:'',
      deviceInfo:'',
      dataSource:this.$cookies.get('dataSource'),
      tel:this.$cookies.get('contactNo'),
      commercialName:this.$cookies.get('commercialName'),
      weiJson:'',
      billShow: true,
      resultShow: false,
      zfShow: true,
      zfzShow: false,
      buttonText: '确认缴费',
      reqsn:'',

      payOrderDate:'',
      payAmount:'',
      customerNumber: this.$cookies.get('commercialNumber'),

    };
  },
  created() {
    //this.getPayStatus()
    this.deviceInfo=JSON.parse(this.$route.query.deviceInfo)
    console.log(this.deviceInfo)

  },

  mounted() {



  },
  methods: {






    call(tel){
      window.location.href = 'tel://'+tel
    },
    payConfirmwx(){
      console.log('1232311')
      const _this=this
      if(_this.amount11==''||_this.amount11=='0.00'||_this.amount11=='0'){
        _this.$vux.toast.show({
          text: '请输入金额',
          type: "warn",
          time:'3000'
        })
        return
      }
      _this.$vux.confirm.show({
        title: '缴费提醒',
        content: '是否已确认缴费信息正确并缴费？',
        confirmText:'确认缴费',
        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          _this.payPostWx()
        }
      })
    },
    payPostWx: async function(){
      this.zfShow = false
      this.zfzShow = true
      this.buttonText = '支付中'
      const _this=this;
      let params = {
        amount:this.amount11*100,
        channelId:'',
        commercialNumber:this.$cookies.get('commercialNo'),
        token:this.$cookies.get('wxToken'),
        payType:this.$cookies.get('payType'),
        userCode:this.deviceInfo.userCode,
        userName:this.deviceInfo.userName,
        userAddress:this.deviceInfo.address,


      };
      console.log(params);
      const response = await this.$api.postjson("/wechat/wxJsPay", params);
      console.log('水费缴纳',response)
      if(response.data.code=='0000'){
        if(_this.$cookies.get('payType')=='2'){
          window.location.href=response.data.data
        }
        else{
          _this.weiJson = response.data.data


          _this.doWeixin()
        }

      }
      else{
        _this.zfShow = true
        _this.zfzShow = false
        _this.buttonText = '确认缴费'
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'3000'
        })
      }
    },
    doWeixin:function() {
      const _this = this
      let json = JSON.parse(_this.weiJson)
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          'appId': json.appId, // 公众号名称，由商户传入
          'timeStamp': json.timeStamp,//记住，这边的timeStamp一定要是字符串类型的，不然会报错
          'nonceStr': json.nonceStr,
          'package': json.package,
          'signType': json.signType,
          'paySign': json.paySign
        },function (res) {
          /* alert(res)*/
          // console.log(res)
          if(res.err_msg === 'get_brand_wcpay_request:ok') {
            _this.zfShow = true
            _this.zfzShow = false
            _this.buttonText = "确认缴费"

            //_this.getPayResultW()
            // success
          }
          else{
            console.log(res)
            _this.zfShow = true
            _this.zfzShow = false
            _this.buttonText = "确认缴费"
            _this.$vux.toast.show({
              text:'支付失败, 请稍后重试',
              type: "warn",
              time:'3000'
            })
          }
        }
      )
      /*iCityBridge.init(function(hasLogin) {
        //hasLogin true:已登录，false:未登录


        iCityBridge.wxPay({
          appid:json.appid,
          timestamp:json.timestamp,
          noncestr:json.noncestr,
          package: json.package,
          sign:json.sign,
          partnerid:json.partnerid,
          prepayid:json.prepayid,

        })
          .then(res => {
            _this.$vux.toast.show({
              text: '支付成功',
              type: 'success',
              time: '5000',
            })
            _this.getBillList()
          })
          .catch(res => {
            _this.$vux.toast.show({
              text: '支付失败',
              type: 'warn',
              time: '3000',
            })
          })
      });*/

    },





  }
};



// WEBPACK FOOTER //
// ./src/views/wx/payOrderW.vue